import form from "emun.auth/register-consumer.formio";
import formioController from "webforms/formio/formio.controller";
import $geo from "webutils/services/geo";
import resolve from "ioc/resolve";
import ServiceBus from "servicestack/service-bus";
import config from "emun.auth/auth.config";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const DEFAULT_SUBMISSION = {
	label: "NewConsumerRequest",
	form: "NewConsumerRequest",
	data: {},
	state: "submitted",
	saved: false,
};

export default class RegisterConsumerController {
	constructor($rootScope, $scope) {
		const $ctrl = this;
		formioController($ctrl, $scope);
		$ctrl.$geo = $geo;
		$ctrl.$rootScope = $rootScope;
		$ctrl.$scope = $scope;
		$ctrl.submission = Object.assign({}, DEFAULT_SUBMISSION);
		$ctrl.bus = new ServiceBus();

		console.debug("RegisterConsumerController", { $scope, form, $ctrl });
		if (form.formioId) {
			$ctrl.getFormIO(form.formioId).then((f) => {
				if (f) {
					$ctrl.form = f.fields;
				}
				$ctrl.loadConsumer();
			});
		} else {
			$ctrl.form = form;
			$ctrl.loadConsumer();
		}
	}

	$apply(...args) {
		const $ctrl = this;
		$ctrl.hideForm = true;
		resolve("$timeout")(() => ($ctrl.hideForm = false), 88);
	}

	loadConsumer() {
		const $ctrl = this;
		if ($ctrl.consumerId) {
			$ctrl.bus
				.read("QueryConsumers/" + $ctrl.consumerId + ".json?Take=1")
				.then((res) => {
					$ctrl.consumer = res.data.results[0];
					$ctrl.loadForm();
				});
		} else {
			$ctrl.loadForm();
		}
	}

	closeAndRedirect(url) {
		const $ctrl = this;
		window.location.href = url;
		$ctrl.$broadcast("$consumerRequestSubmitted");
	}

	// https://github.com/formio/ngFormio/wiki/Responding-to-Form-Events
	formSubmission(e, submission) {
		const $ctrl = this;
		console.debug("formSubmission", { e, submission, $ctrl });
		$ctrl.submission = submission;
		if (submission.events.RetailerRequestReceived) {
			$ctrl.onRetailerRequestReceived(
				submission.events.RetailerRequestReceived
			);
		} else {
			$ctrl.$broadcast("$consumerRequestSubmitted");
		}
		if (config.consumerRequestRedirectUrl) {
			window.location.href = config.consumerRequestRedirectUrl;
		} else if (config.retailerRequestRedirectUrl) {
			window.location.href = config.retailerRequestRedirectUrl;
		}
	}

	onConsumerRequestReceived(consumerRequestReceived) {
		const $ctrl = this;
		console.debug("onConsumerRequestReceived", {
			consumerRequestReceived,
			$ctrl,
		});
		$ctrl.request = {};
		$ctrl.response = consumerRequestReceived;
		$ctrl.submitted = new Date();
		$ctrl.$broadcast("$consumerRequestSubmitted", { consumerRequestReceived });
		if (
			consumerRequestReceived.userRegistered &&
			!$ctrl.$session.isSalesManagementMode()
		) {
			$ctrl.onUserRegistered(
				consumerRequestReceived.userRegistered,
				consumerRequestReceived
			);
		}
	}

	onUserRegistered(userRegistered, consumerRequestReceived) {
		const $ctrl = this;
		const $timeout = resolve("$timeout");
		$timeout(() => $ctrl.$session.get(), 800);
		$ctrl.$broadcast("$onAuthenticated", consumerRequestReceived);
	}

	calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
		const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
		return { width: srcWidth * ratio, height: srcHeight * ratio };
	}

	exportForm() {
		const $ctrl = this;
		html2canvas(document.querySelector("#registrationForm")).then((canvas) => {
			const doc = new jsPDF("p", "mm");
			var imgData = canvas.toDataURL("image/png");
			var imgWidth = 210;
			var pageHeight = 290;
			var imgHeight = (canvas.height * imgWidth) / canvas.width;
			var heightLeft = imgHeight;
			var position = 0;

			doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;

			while (heightLeft >= 0) {
				console.info("heightLeft", heightLeft);
				console.info("imgHeight", imgHeight);
				position = heightLeft - imgHeight;
				doc.addPage();
				doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
				heightLeft -= pageHeight;
			}

			doc.save("registration.pdf");
		});
	}

	loadForm() {
		let $ctrl = this;
		console.debug("loadForm", $ctrl);

		//if ($ctrl.$geo && $ctrl.$geo.countries) {
		//	$ctrl.submission.data.countries = $ctrl.$geo.countries;
		//}
		//if ($ctrl.$geo && $ctrl.$geo.provinces) {
		//	$ctrl.submission.data.provinces = $ctrl.$geo.provinces;
		//}
		//if ($ctrl.consumer) {
		//	$ctrl.submission = {
		//		//			label: "register-retailer",
		//		label: "UpdateConsumer",
		//		data: {
		//			type: "",
		//			longForm: true,
		//			consumerId: $ctrl.consumer.id,
		//		},
		//	};
		//	if ($ctrl.retailer.tags) {
		//		$ctrl.submissionId = $ctrl.retailer.tags.AuthorizationForm;
		//		if ($ctrl.submissionId) {
		//			$ctrl.bus
		//				.send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
		//				.then(({ data }) => {
		//					if (data.results.length) {
		//						data.results[0].data.longForm = true;
		//						// pulses/978470823
		//						for (const p in data.results[0].data) {
		//							if (
		//								p.indexOf("ingCountry") &&
		//								data.results[0].data[p] === "United States"
		//							) {
		//								data.results[0].data[p] === "US";
		//							}
		//						}
		//						$ctrl.submission = {
		//							// label: "register-retailer",
		//							label: "UpdateRetailer",
		//							retailerId: $ctrl.retailer.id,
		//							data: data.results[0].data,
		//						};
		//					}
		//				});
		//		}
		//	}
		//}
	}
}
